<div *ngIf="nodeValue" class="h-full bg-bluegray-50">
   <!-- Header -->
   <div
      class="flex flex-column gap-3 w-full px-4"
      style="background: var(--pay-surface-0); border-bottom: 1px solid var(--pay-border)"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4" (click)="this.closeSidebar.emit()">
         <lucide-icon name="x" [size]="16" style="color: var(--pay-fg-3)"></lucide-icon>
      </span>

      <div class="flex align-items-center w-full gap-3 pb-3">
         <div
            class="flex align-items-center justify-content-center border-round-lg flex-shrink-0"
            style="width: 2.5rem; height: 2.5rem; background: var(--pay-indigo-bg)"
         >
            <lucide-icon name="phone" [size]="15" style="color: var(--pay-primary)"></lucide-icon>
         </div>
         <div class="flex flex-column gap-1">
            <span class="font-semibold" style="font-size: var(--pay-text-lg); color: var(--pay-fg-1)">
               {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.TITLE' | translate }}
            </span>
            <span style="font-size: var(--pay-text-sm); color: var(--pay-fg-3)">
               {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.DESCRIPTION' | translate }}
            </span>
         </div>
      </div>

      <div *ngIf="visibleTabs().length > 1" class="tab-nav tab-nav--centered w-full">
         <button
            *ngFor="let tab of visibleTabs()"
            type="button"
            class="tab-nav__item"
            [class.tab-nav__item--active]="activeTab() === tab.value"
            (click)="activeTab.set(tab.value)"
         >
            <lucide-icon *ngIf="tab.value === 'preview'" name="eye" [size]="15"></lucide-icon>
            <lucide-icon *ngIf="tab.value === 'config'" name="settings" [size]="15"></lucide-icon>
            <span>{{ tab.label }}</span>
         </button>
      </div>
   </div>

   <!-- ─── Preview Tab ──────────────────────────────────────────────────────── -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <!-- ── AI Agent block ───────────────────────────────────────────── -->
         <div *ngIf="selectedAgentDetails()" class="flex flex-column gap-2">
            <!-- Section label -->
            <div class="flex align-items-center gap-2 px-1">
               <lucide-icon name="bot" [size]="13" style="color: var(--pay-indigo)"></lucide-icon>
               <span
                  style="
                     font-size: var(--pay-text-xs);
                     font-weight: 600;
                     letter-spacing: 0.07em;
                     text-transform: uppercase;
                     color: var(--pay-indigo);
                  "
               >
                  {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.AGENT_SECTION_LABEL' | translate }}
               </span>
            </div>

            <!-- Agent container -->
            <div
               class="flex flex-column gap-0 border-1 border-round-xl overflow-hidden"
               style="border-color: var(--pay-indigo-bg); background: var(--pay-surface-0)"
            >
               <!-- Agent name row -->
               <div class="flex flex-row gap-3 align-items-center p-4">
                  <div
                     class="border-round-lg flex align-items-center justify-content-center flex-shrink-0"
                     style="width: 2.25rem; height: 2.25rem; background: var(--pay-indigo-bg)"
                  >
                     <lucide-icon name="user" [size]="16" style="color: var(--pay-indigo)"></lucide-icon>
                  </div>
                  <div class="flex flex-column gap-0">
                     <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                        {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.AGENT' | translate }}
                     </span>
                     <span class="font-semibold" style="font-size: var(--pay-text-md); color: var(--pay-fg-1)">
                        {{ selectedAgentDetails().name }}
                     </span>
                  </div>
               </div>

               <!-- Context (optional) -->
               <div
                  *ngIf="selectedAgentDetails().context"
                  class="flex flex-row gap-3 align-items-start p-4"
                  style="border-top: 1px solid var(--pay-indigo-bg)"
               >
                  <div
                     class="border-round-lg flex align-items-center justify-content-center flex-shrink-0"
                     style="width: 2.25rem; height: 2.25rem; background: var(--pay-indigo-bg)"
                  >
                     <lucide-icon name="file-text" [size]="15" style="color: var(--pay-indigo)"></lucide-icon>
                  </div>
                  <div class="flex flex-column gap-1 min-w-0 flex-1">
                     <div class="flex align-items-center justify-content-between">
                        <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                           {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.CONTEXT' | translate }}
                        </span>
                        <button
                           type="button"
                           class="flex align-items-center gap-1 cursor-pointer border-none bg-transparent p-0"
                           style="font-size: var(--pay-text-xs); color: var(--pay-indigo)"
                           (click)="contextCollapsed.set(!contextCollapsed())"
                        >
                           <lucide-icon
                              [name]="contextCollapsed() ? 'chevron-down' : 'chevron-up'"
                              [size]="12"
                           ></lucide-icon>
                           {{ contextCollapsed() ? '+ más' : '- menos' }}
                        </button>
                     </div>
                     <span
                        class="white-space-pre-wrap"
                        style="font-size: var(--pay-text-sm); color: var(--pay-fg-2)"
                        [style.display]="contextCollapsed() ? '-webkit-box' : 'block'"
                        [style.-webkit-line-clamp]="contextCollapsed() ? '3' : 'unset'"
                        [style.-webkit-box-orient]="contextCollapsed() ? 'vertical' : 'unset'"
                        [style.overflow]="contextCollapsed() ? 'hidden' : 'visible'"
                     >
                        {{ selectedAgentDetails().context }}
                     </span>
                  </div>
               </div>

               <!-- Custom fields (optional) -->
               <div
                  *ngIf="selectedAgentDetails().customFields?.length > 0"
                  class="flex flex-row gap-3 align-items-start p-4"
                  style="border-top: 1px solid var(--pay-indigo-bg)"
               >
                  <div
                     class="border-round-lg flex align-items-center justify-content-center flex-shrink-0"
                     style="width: 2.25rem; height: 2.25rem; background: var(--pay-indigo-bg)"
                  >
                     <lucide-icon name="tag" [size]="15" style="color: var(--pay-indigo)"></lucide-icon>
                  </div>
                  <div class="flex flex-column gap-2 flex-1">
                     <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                        {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.CUSTOM_FIELDS' | translate }}
                     </span>
                     <div class="flex flex-wrap gap-2">
                        <div
                           *ngFor="let field of selectedAgentDetails().customFields"
                           class="flex align-items-center gap-1 px-2 py-1 border-round-lg"
                           style="background: var(--pay-indigo-bg)"
                        >
                           <lucide-icon name="tag" [size]="11" style="color: var(--pay-indigo)"></lucide-icon>
                           <span
                              style="
                                 font-size: var(--pay-text-xs);
                                 color: var(--pay-fg-1);
                                 font-family: var(--pay-font-id), 'Roboto', sans-serif;
                              "
                              >{{ field }}</span
                           >
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Call intervals (optional) -->
               <div
                  *ngIf="selectedAgentDetails().callIntervals?.length > 0"
                  class="flex flex-row gap-3 align-items-start p-4"
                  style="border-top: 1px solid var(--pay-indigo-bg)"
               >
                  <div
                     class="border-round-lg flex align-items-center justify-content-center flex-shrink-0"
                     style="width: 2.25rem; height: 2.25rem; background: var(--pay-indigo-bg)"
                  >
                     <lucide-icon name="clock" [size]="15" style="color: var(--pay-indigo)"></lucide-icon>
                  </div>
                  <div class="flex flex-column gap-2 flex-1">
                     <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                        {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.CALL_INTERVALS' | translate }}
                     </span>
                     <div class="flex flex-column gap-1">
                        <div
                           *ngFor="let interval of selectedAgentDetails().callIntervals"
                           class="flex align-items-center gap-2 px-2 py-1 border-round-lg"
                           style="background: var(--pay-indigo-bg)"
                        >
                           <lucide-icon name="clock" [size]="11" style="color: var(--pay-indigo)"></lucide-icon>
                           <span class="font-semibold" style="font-size: var(--pay-text-xs); color: var(--pay-fg-1)">
                              {{ interval.start }} – {{ interval.finish }}
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <!-- ── Call config block ─────────────────────────────────────────── -->
         <div class="flex flex-column gap-2">
            <!-- Section label -->
            <div class="flex align-items-center gap-2 px-1">
               <lucide-icon name="phone" [size]="13" style="color: var(--pay-fg-3)"></lucide-icon>
               <span
                  style="
                     font-size: var(--pay-text-xs);
                     font-weight: 600;
                     letter-spacing: 0.07em;
                     text-transform: uppercase;
                     color: var(--pay-indigo);
                  "
               >
                  {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.CALL_SECTION_LABEL' | translate }}
               </span>
            </div>

            <div class="flex flex-column gap-3">
               <!-- Contact all -->
               <div
                  class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
               >
                  <div class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                     <lucide-icon name="users" [size]="18" style="color: var(--pay-primary)"></lucide-icon>
                  </div>
                  <div class="flex flex-column gap-1">
                     <span class="font-medium text-500">
                        {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.CONTACT_ALL' | translate }}
                     </span>
                     <span
                        class="text-xl font-semibold"
                        [style.color]="isContactAll() ? 'var(--pay-primary)' : 'var(--pay-fg-3)'"
                     >
                        {{
                           isContactAll()
                              ? ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.YES' | translate)
                              : ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.NO' | translate)
                        }}
                     </span>
                  </div>
               </div>

               <!-- Retry failed calls -->
               <div
                  class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
               >
                  <div class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                     <lucide-icon name="refresh-cw" [size]="18" style="color: var(--pay-primary)"></lucide-icon>
                  </div>
                  <div class="flex flex-column gap-1">
                     <span class="font-medium text-500">
                        {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.RETRY' | translate }}
                     </span>
                     <span
                        class="text-xl font-semibold"
                        [style.color]="isRetryFailCalls() ? 'var(--pay-primary)' : 'var(--pay-fg-3)'"
                     >
                        {{
                           isRetryFailCalls()
                              ? ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.YES' | translate)
                              : ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.NO' | translate)
                        }}
                     </span>
                  </div>
               </div>

               <!-- Retry slots -->
               <div
                  *ngIf="isRetryFailCalls()"
                  class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-column gap-3"
               >
                  <div class="flex align-items-center gap-3">
                     <div
                        class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem"
                     >
                        <lucide-icon name="clock" [size]="18" style="color: var(--pay-primary)"></lucide-icon>
                     </div>
                     <div class="flex flex-column gap-1">
                        <span class="font-medium text-500">
                           {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.RETRY_SLOTS_TITLE' | translate }}
                        </span>
                        <span class="text-xs text-500">
                           {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.RETRY_SLOTS_SUBTITLE' | translate }}
                        </span>
                     </div>
                  </div>
                  <div class="flex flex-column gap-2 pl-5">
                     <ng-container *ngFor="let range of retryTimeRanges(); let i = index">
                        <div
                           *ngIf="range.selected"
                           class="flex align-items-center gap-2 p-2 border-round-lg"
                           style="background: var(--pay-primary-lighter)"
                        >
                           <lucide-icon name="clock" [size]="13" style="color: var(--pay-primary)"></lucide-icon>
                           <span class="text-xs text-500">
                              {{
                                 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.RETRY_LABEL'
                                    | translate: { number: i + 1 }
                              }}
                           </span>
                           <span class="font-semibold text-sm" style="color: var(--pay-fg-1)">
                              {{ range.from }} – {{ range.to }}
                           </span>
                        </div>
                     </ng-container>
                  </div>
               </div>

               <!-- Actions -->
               <div class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-column gap-3">
                  <div class="flex align-items-center gap-3">
                     <div
                        class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem"
                     >
                        <lucide-icon name="arrow-right" [size]="18" style="color: var(--pay-primary)"></lucide-icon>
                     </div>
                     <span class="font-medium text-500">
                        {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.PREVIEW.ACTIONS' | translate }}
                     </span>
                  </div>
                  <div class="flex flex-column gap-2 pl-5">
                     <div
                        *ngFor="let action of actions()"
                        class="p-3 border-round-lg flex flex-column gap-1"
                        style="background: var(--pay-primary-lighter); border-left: 3px solid var(--pay-primary)"
                     >
                        <span class="text-xs text-500 font-italic">{{ action.situation || '-' }}</span>
                        <span class="font-semibold text-sm" style="color: var(--pay-fg-1)">
                           {{
                              action.action === 'feedback'
                                 ? ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.FEEDBACK'
                                   | translate)
                                 : ('DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.ASSIGN_CAMPAIGN'
                                   | translate)
                           }}
                        </span>
                        <div *ngIf="action.action === 'assignCampaign'">
                           <a
                              (click)="viewCampaign(action.campaign)"
                              class="cursor-pointer flex align-items-center gap-1"
                              style="font-size: var(--pay-text-xs); color: var(--pay-primary)"
                           >
                              {{ getCampaignName(action.campaign) }}
                              <lucide-icon
                                 name="external-link"
                                 [size]="11"
                                 style="color: var(--pay-primary)"
                              ></lucide-icon>
                           </a>
                        </div>
                     </div>
                     <div *ngIf="actions().length === 0" class="flex align-items-center gap-2 text-500 text-sm italic">
                        <lucide-icon name="info" [size]="13"></lucide-icon>
                        {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SUBTITLE' | translate }}
                     </div>
                  </div>
               </div>
            </div>
            <!-- end call config items -->
         </div>
         <!-- end call config block -->
      </div>
   </div>

   <!-- ─── Config Tab ───────────────────────────────────────────────────────── -->
   <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
      <div class="flex flex-column gap-5">
         <!-- Agent section -->
         <section class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold" style="font-size: var(--pay-text-md); color: var(--pay-fg-1)">
                  {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.TITLE' | translate }}
               </span>
               <span style="font-size: var(--pay-text-sm); color: var(--pay-fg-3)">
                  {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.SUBTITLE' | translate }}
               </span>
            </div>

            <p-dropdown
               [options]="agents()"
               [ngModel]="selectedAgentId()"
               (ngModelChange)="onAgentChange($event)"
               optionLabel="name"
               optionValue="id"
               [placeholder]="
                  'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.DROPDOWN_LABEL' | translate
               "
               class="w-full"
               styleClass="w-full"
            ></p-dropdown>

            <!-- Agent info card -->
            <div
               *ngIf="selectedAgentDetails()"
               class="p-4 border-1 border-round-xl flex flex-column gap-3"
               style="background: var(--pay-surface-0); border-color: var(--pay-border)"
            >
               <div class="flex align-items-center gap-3">
                  <div
                     class="flex align-items-center justify-content-center border-round-lg flex-shrink-0"
                     style="width: 2.5rem; height: 2.5rem; background: var(--pay-indigo-bg)"
                  >
                     <lucide-icon name="user" [size]="15" style="color: var(--pay-primary)"></lucide-icon>
                  </div>
                  <div class="flex flex-column gap-1">
                     <span class="font-semibold" style="font-size: var(--pay-text-md); color: var(--pay-fg-1)">
                        {{ selectedAgentDetails().name }}
                     </span>
                  </div>
               </div>

               <div *ngIf="selectedAgentDetails().context" class="flex flex-column gap-2">
                  <div class="flex align-items-center justify-content-between">
                     <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                        {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.INFO.CONTEXT' | translate }}
                     </span>
                     <button
                        type="button"
                        class="flex align-items-center gap-1 cursor-pointer border-none bg-transparent p-0"
                        style="font-size: var(--pay-text-xs); color: var(--pay-primary)"
                        (click)="contextCollapsed.set(!contextCollapsed())"
                     >
                        <lucide-icon
                           [name]="contextCollapsed() ? 'chevron-down' : 'chevron-up'"
                           [size]="12"
                        ></lucide-icon>
                        {{ contextCollapsed() ? '+ más' : '- menos' }}
                     </button>
                  </div>
                  <div class="p-3 border-round-lg" style="background: var(--pay-indigo-bg)">
                     <span
                        class="white-space-pre-wrap"
                        style="font-size: var(--pay-text-xs); color: var(--pay-fg-2)"
                        [style.display]="contextCollapsed() ? '-webkit-box' : 'block'"
                        [style.-webkit-line-clamp]="contextCollapsed() ? '3' : 'unset'"
                        [style.-webkit-box-orient]="contextCollapsed() ? 'vertical' : 'unset'"
                        [style.overflow]="contextCollapsed() ? 'hidden' : 'visible'"
                     >
                        {{ selectedAgentDetails().context }}
                     </span>
                  </div>
               </div>

               <div *ngIf="selectedAgentDetails().customFields?.length > 0" class="flex flex-column gap-2">
                  <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                     {{
                        'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.INFO.CUSTOM_FIELDS' | translate
                     }}
                  </span>
                  <div
                     *ngFor="let field of selectedAgentDetails().customFields"
                     class="flex align-items-center gap-2 p-2 border-round-lg"
                     style="background: var(--pay-indigo-bg)"
                  >
                     <lucide-icon name="tag" [size]="11" style="color: var(--pay-indigo)"></lucide-icon>
                     <span
                        style="
                           font-size: var(--pay-text-xs);
                           color: var(--pay-fg-1);
                           font-family: var(--pay-font-id), 'Roboto', sans-serif;
                        "
                        >{{ field }}</span
                     >
                  </div>
               </div>

               <div *ngIf="selectedAgentDetails().callIntervals?.length > 0" class="flex flex-column gap-2">
                  <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                     {{
                        'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.AGENT_SECTION.INFO.CALL_INTERVALS'
                           | translate
                     }}
                  </span>
                  <div
                     *ngFor="let interval of selectedAgentDetails().callIntervals"
                     class="flex align-items-center gap-2 p-2 border-round-lg"
                     style="background: var(--pay-primary-lighter)"
                  >
                     <lucide-icon name="clock" [size]="11" style="color: var(--pay-primary)"></lucide-icon>
                     <span class="font-semibold" style="font-size: var(--pay-text-xs); color: var(--pay-fg-1)">
                        {{ interval.start }} – {{ interval.finish }}
                     </span>
                  </div>
               </div>
            </div>
         </section>

         <p-divider></p-divider>

         <!-- Contact all + Retry checkboxes -->
         <section class="flex flex-column gap-3">
            <div class="flex align-items-center gap-2">
               <p-checkbox
                  [(ngModel)]="isContactAll"
                  [binary]="true"
                  (onChange)="applyChanges()"
                  id="isContactAll"
               ></p-checkbox>
               <label for="isContactAll" style="font-size: var(--pay-text-sm); color: var(--pay-fg-2)">
                  {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.CONTACT_ALL.LABEL' | translate }}
               </label>
            </div>
            <div class="flex align-items-center gap-2">
               <p-checkbox
                  [(ngModel)]="isRetryFailCalls"
                  [binary]="true"
                  (onChange)="onRetryFailCallsChange()"
                  id="isRetryFailCalls"
               ></p-checkbox>
               <label for="isRetryFailCalls" style="font-size: var(--pay-text-sm); color: var(--pay-fg-2)">
                  {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.LABEL' | translate }}
               </label>
            </div>
         </section>

         <!-- Retry time slots -->
         <section *ngIf="isRetryFailCalls()" class="flex flex-column gap-3 pl-4">
            <span class="font-semibold" style="font-size: var(--pay-text-sm); color: var(--pay-fg-2)">
               {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.SECTION_TITLE' | translate }}
            </span>
            <div class="flex flex-column gap-3">
               <div *ngFor="let range of retryTimeRanges(); let i = index">
                  <div
                     class="p-3 border-1 border-round-lg flex flex-column gap-3"
                     style="border-color: var(--pay-border); background: var(--pay-surface-0)"
                  >
                     <div class="flex align-items-center gap-2">
                        <p-checkbox
                           [(ngModel)]="range.selected"
                           [binary]="true"
                           (onChange)="onRetryRangeChange()"
                           [id]="'retry-' + i"
                        ></p-checkbox>
                        <label
                           [for]="'retry-' + i"
                           class="flex align-items-center gap-1"
                           style="font-size: var(--pay-text-sm); color: var(--pay-fg-2)"
                        >
                           <lucide-icon name="clock" [size]="12" style="color: var(--pay-fg-3)"></lucide-icon>
                           {{
                              'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.RETRY_LABEL'
                                 | translate: { number: i + 1 }
                           }}
                        </label>
                     </div>
                     <div *ngIf="range.selected" class="flex gap-4">
                        <div class="flex flex-column gap-1 flex-1">
                           <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                              {{
                                 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.FROM' | translate
                              }}
                           </span>
                           <input
                              pInputText
                              type="time"
                              [(ngModel)]="range.from"
                              (change)="onRetryRangeChange()"
                              class="p-inputtext-sm"
                           />
                        </div>
                        <div class="flex flex-column gap-1 flex-1">
                           <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                              {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.RETRY_FAIL_CALLS.TO' | translate }}
                           </span>
                           <input
                              pInputText
                              type="time"
                              [(ngModel)]="range.to"
                              (change)="onRetryRangeChange()"
                              class="p-inputtext-sm"
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <p-divider></p-divider>

         <!-- Actions -->
         <section class="flex flex-column gap-3">
            <div class="flex justify-content-between align-items-center">
               <div class="flex flex-column gap-1">
                  <span class="font-semibold" style="font-size: var(--pay-text-md); color: var(--pay-fg-1)">
                     {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.TITLE' | translate }}
                  </span>
                  <span style="font-size: var(--pay-text-xs); color: var(--pay-fg-3)">
                     {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SUBTITLE' | translate }}
                  </span>
               </div>
               <p-button
                  [label]="'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.ADD_BUTTON' | translate"
                  icon="pi pi-plus"
                  size="small"
                  text="true"
                  severity="primary"
                  (onClick)="addAction()"
               ></p-button>
            </div>

            <div class="flex flex-column gap-3">
               <div *ngFor="let action of actions(); let i = index">
                  <!-- Read mode -->
                  <div
                     *ngIf="!editingActions().has(i)"
                     class="p-4 border-1 border-round-xl relative flex flex-column gap-2"
                     style="
                        background: var(--pay-primary-lighter);
                        border-color: var(--pay-border);
                        border-left: 3px solid var(--pay-primary);
                     "
                  >
                     <div class="absolute top-0 right-0 p-3 flex gap-2">
                        <p-button
                           icon="pi pi-pencil"
                           severity="secondary"
                           [rounded]="true"
                           size="small"
                           (click)="editAction(i)"
                        ></p-button>
                        <p-button
                           icon="pi pi-trash"
                           severity="secondary"
                           [rounded]="true"
                           size="small"
                           (click)="removeAction(i)"
                        ></p-button>
                     </div>
                     <div class="flex flex-column gap-1">
                        <span
                           style="
                              font-size: var(--pay-text-xs);
                              font-weight: 600;
                              letter-spacing: 0.07em;
                              text-transform: uppercase;
                              color: var(--pay-fg-3);
                           "
                        >
                           {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.IF_THIS_HAPPENS' | translate }}
                        </span>
                        <span class="font-semibold" style="font-size: var(--pay-text-sm); color: var(--pay-fg-1)">
                           {{ action.situation || '-' }}
                        </span>
                     </div>
                     <div class="flex flex-column gap-1">
                        <span
                           style="
                              font-size: var(--pay-text-xs);
                              font-weight: 600;
                              letter-spacing: 0.07em;
                              text-transform: uppercase;
                              color: var(--pay-fg-3);
                           "
                        >
                           {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SYSTEM_ACTION' | translate }}
                        </span>
                        <div style="font-size: var(--pay-text-sm); color: var(--pay-primary)">
                           {{
                              (action.action === 'feedback'
                                 ? 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.FEEDBACK'
                                 : 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.ASSIGN_CAMPAIGN'
                              ) | translate
                           }}
                           <span *ngIf="action.action === 'assignCampaign'" class="font-semibold"
                              >:
                              <a
                                 (click)="viewCampaign(action.campaign)"
                                 class="cursor-pointer hover:underline"
                                 style="color: var(--pay-primary)"
                              >
                                 {{ getCampaignName(action.campaign) }}
                                 <lucide-icon
                                    name="external-link"
                                    [size]="11"
                                    style="color: var(--pay-primary)"
                                 ></lucide-icon>
                              </a>
                           </span>
                        </div>
                     </div>
                  </div>

                  <!-- Edit mode -->
                  <div
                     *ngIf="editingActions().has(i)"
                     [id]="'action-form-' + i"
                     class="p-4 border-1 border-round-xl relative flex flex-column gap-3"
                     style="background: var(--pay-surface-0); border-color: var(--pay-border)"
                  >
                     <div class="absolute top-0 right-0 p-3">
                        <p-button
                           icon="pi pi-trash"
                           severity="danger"
                           [rounded]="true"
                           size="small"
                           [outlined]="true"
                           (click)="removeAction(i)"
                        ></p-button>
                     </div>
                     <div class="flex flex-column gap-1 pt-3">
                        <span class="font-semibold" style="font-size: var(--pay-text-sm); color: var(--pay-fg-2)">
                           {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.IF_THIS_HAPPENS' | translate }}
                        </span>
                        <input
                           pInputText
                           [(ngModel)]="action.situation"
                           placeholder="Ej: No contesta, Interesado..."
                           class="w-full"
                        />
                     </div>
                     <div class="flex flex-column gap-1">
                        <span class="font-semibold" style="font-size: var(--pay-text-sm); color: var(--pay-fg-2)">
                           {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SYSTEM_ACTION' | translate }}
                        </span>
                        <div class="seg-control w-full">
                           <button
                              type="button"
                              class="seg-control__btn"
                              [class.seg-control__btn--active]="action.action === 'feedback'"
                              (click)="action.action = 'feedback'; applyChanges()"
                           >
                              {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.FEEDBACK' | translate }}
                           </button>
                           <button
                              type="button"
                              class="seg-control__btn"
                              [class.seg-control__btn--active]="action.action === 'assignCampaign'"
                              (click)="action.action = 'assignCampaign'; applyChanges()"
                           >
                              {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.OPTIONS.ASSIGN_CAMPAIGN' | translate }}
                           </button>
                        </div>
                     </div>
                     <div *ngIf="action.action === 'assignCampaign'" class="flex flex-column gap-1">
                        <span class="font-semibold" style="font-size: var(--pay-text-sm); color: var(--pay-fg-2)">
                           {{ 'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SELECT_CAMPAIGN' | translate }}
                        </span>
                        <app-tree-select
                           [nodes]="campaignOptions()"
                           [selectedKeys]="action.campaign ? [action.campaign] : []"
                           [enableSearch]="true"
                           placeholder="Seleccione campaña"
                           (selectionChange)="onCampaignSelectionChange(i, $event)"
                        ></app-tree-select>
                     </div>
                     <div class="flex justify-content-end mt-2">
                        <p-button
                           [label]="'DATA.MODULES.INSPECTORS.MAKE_OUTBOUND_CALL.CONFIG.ACTIONS.SAVE_RULE' | translate"
                           icon="pi pi-check"
                           size="small"
                           (onClick)="saveAction(i)"
                        ></p-button>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <p-messages *ngIf="errors().length > 0" severity="error" [closable]="false">
            <ng-template pTemplate="content">
               <div class="flex flex-column gap-1">
                  <div *ngFor="let error of errors()">{{ getErrorMessage(error) }}</div>
               </div>
            </ng-template>
         </p-messages>
      </div>
   </div>
</div>
